import React, { createRef, useRef, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import DrawSign from "./DrawSign";
import FooterButtonGroup from "../layout/FooterButtonGroup";
import { receiptStepState } from "../../../recoil/pageStep";
import { useForm } from "react-hook-form";
import {
  firstReceiptFormState,
  isDrawSignModalOpenState,
  receiptSubmitState,
  signFileState,
} from "../../../recoil/receipt";
import Agree1 from "../agree/agree1";
import Agree2 from "../agree/agree2";
import Agree3 from "../agree/agree3";
import Agree4 from "../agree/agree4";
import Agree5 from "../agree/agree5";
import ButtonGroup from "../../atoms/layout/ButtonGroup";
import Button from "../../atoms/buttons/Button";

const AgreeForm = ({ onSubmit }) => {
  const { register } = useForm();

  const [receiptStep, setReceiptStep] = useRecoilState(receiptStepState);
  const firstReceiptForm = useRecoilValue(firstReceiptFormState);
  const [submitState, setSubmitState] = useRecoilState(receiptSubmitState);

  const [isDrawSignModalOpen, setIsDrawSignModalOpen] = useRecoilState(
    isDrawSignModalOpenState
  );
  const signFileBlob = useRecoilValue(signFileState);

  const [agreement, setAgreement] = useState(false);

  const [drawCheck, setDrawCheck] = useState(true);

  // const [isOpen, setOpen] = useState(false);
  const [isAgree1pdf, setAgree1pdf] = useState(false);
  const [isAgree1, setAgree1] = useState(false);

  const nextOnClick = () => {
    if (!isAgree1) {
      alert("개인정보 수집·이용 내역을 동의해 주세요.");
      return false;
    }

    if (drawCheck) {
      alert("전자서명을 진행해주세요");
      return false;
    }
    setAgreement(true);
    if (agreement) {
      setReceiptStep(receiptStep + 2);
    }
  };

  return (
    <div>
      <link rel="stylesheet" type="text/css" href="/css/admin.css" />
      <div className="candidate-agree cen-944">
        <div className="privacy-agreement">
          <p className="agree-title"> [필수]개인정보 동의서</p>
          <div className="agree-cont">
            <div className="flex-top">
              <div className="agree-cont-title">
                <p>개인정보의 수집 · 이용에 관한 동의서</p>
              </div>
              <div className="agree-pdf-view">
                <div className="view-full-text agree-cont-border-b flex">
                  <div>
                    <span className="agree-pdf-title">
                      개인정보 수집·이용 내역
                    </span>
                  </div>
                  <div>
                    <label className="radio-container">
                      <input
                        className="agree"
                        type="checkbox"
                        disabled={true}
                        checked={isAgree1}
                      />
                      <span
                        className="checkmark"
                        onClick={() => {
                          setAgree1pdf(true);
                        }}
                      ></span>
                      <span
                        className="check-title"
                        onClick={() => {
                          setAgree1pdf(true);
                        }}
                      >
                        동의
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="elec-sign">
          <p className="agree-title">[필수] 전자서명</p>
          <div className="cont-border sign-cont">
            <div className="today-date text-align-center">
              <span>{new Date().getFullYear()} 년</span>
              <span>{new Date().getMonth() + 1} 월</span>
              <span>{new Date().getDate()} 일</span>
            </div>
            <div className="indi-info flex">
              <div className="sign-info">
                <div className="sign-info-b">
                  <span>생년월일</span>
                  <input
                    className="sign-input birth"
                    type="text"
                    value={`${firstReceiptForm.birthday_YMD}`}
                    readOnly
                  />
                </div>
                <div className="sign-info-b">
                  <span>이름</span>
                  <input
                    className="sign-input name"
                    type="text"
                    value={firstReceiptForm.name}
                    readOnly
                  />
                </div>
              </div>
              <div className="flex">
                <span>서명</span>
                <div className="sign-example">
                  {signFileBlob.length !== 0 && (
                    <img src={signFileBlob} height="100%" width="100%" />
                  )}
                </div>
              </div>
            </div>
            <div className="text-align-right">
              {/*<DrawSign*/}
              {/*  isOpen={isDrawSignModalOpen}*/}
              {/*  setIsOpen={setIsDrawSignModalOpen}*/}
              {/*  setDrawCheck = {setDrawCheck}*/}
              {/*/>*/}
              <span className="btn-explicate">
                ※ 서명등록 버튼을 눌러주세요.
              </span>
              <button
                type="button"
                className="sign-save c-btn"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
                onClick={() => setIsDrawSignModalOpen(true)}
              >
                서명등록
              </button>
            </div>

            <div
              className="modal fade agree-pdf"
              id="agree2"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabIndex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="false"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header flex">
                    <p className="sign-top-title" id="staticBackdropLabel">
                      영어말하기 평가
                    </p>
                    <button
                      type="button"
                      className="close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body confirm-sec">
                    <div className="modal-title">
                      <p>민감정보 수집·이용 내역에 관한 동의서</p>
                    </div>
                    <div className="modal-cont">
                      <div className="pdf-box">
                        <embed
                          src="pdf/agree1.pdf"
                          type="application/pdf"
                          width="100"
                          height="100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer text-align-right">
                    <button
                      type="button"
                      className="modal-btn modal-close-btn"
                      data-bs-dismiss="modal"
                    >
                      닫기
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade agree-pdf"
              id="agree3"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabIndex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header flex">
                    <p className="sign-top-title" id="staticBackdropLabel">
                      영어말하기 평가
                    </p>
                    <button
                      type="button"
                      className="close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body confirm-sec">
                    <div className="modal-title">
                      <p>민감정보제3자제공에 관한 동의서</p>
                    </div>
                    <div className="modal-cont">
                      <div className="pdf-box">
                        <embed
                          src="pdf/3.개인정보 제3자 제공 내역.pdf"
                          type="application/pdf"
                          width="100"
                          height="100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer text-align-right">
                    <button
                      type="button"
                      className="modal-btn modal-close-btn"
                      data-bs-dismiss="modal"
                    >
                      닫기
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade agree-pdf"
              id="agree4"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabIndex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header flex">
                    <p className="sign-top-title" id="staticBackdropLabel">
                      영어말하기 평가
                    </p>
                    <button
                      type="button"
                      className="close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body confirm-sec">
                    <div className="modal-title">
                      <p>주민등록번호 수집·이용 사항 고지에 관한 동의서</p>
                    </div>
                    <div className="modal-cont">
                      <div className="pdf-box">
                        <embed
                          src="pdf/4.민감정보제3자제공.pdf"
                          type="application/pdf"
                          width="100"
                          height="100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer text-align-right">
                    <button
                      type="button"
                      className="modal-btn modal-close-btn"
                      data-bs-dismiss="modal"
                    >
                      닫기
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade agree-pdf"
              id="agree5"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabIndex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header flex">
                    <p className="sign-top-title" id="staticBackdropLabel">
                      영어말하기 평가
                    </p>
                    <button
                      type="button"
                      className="close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body confirm-sec">
                    <div className="modal-title">
                      <p>크라우드워커 업무위탁 계약서</p>
                    </div>
                    <div className="modal-cont">
                      <div className="pdf-box">
                        <embed
                          src="pdf/크라우드워커 업무위탁 계약서(최종 검수 완료).pdf"
                          type="application/pdf"
                          width="100"
                          height="100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer text-align-right">
                    <button
                      type="button"
                      className="modal-btn modal-close-btn"
                      data-bs-dismiss="modal"
                    >
                      닫기
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="base-sec-bottom">
        <ButtonGroup>
          <Button
            className="bottombtn bottombtn-w"
            size="lg"
            color="secondary"
            type="button"
            onClick={() => {
              setReceiptStep(receiptStep - 1);
            }}
          >
            이전
          </Button>

          {isAgree1 && !drawCheck ? (
            <Button
              className="bottombtn bottombtn-b"
              size="lg"
              color="primary"
              type="submit"
            >
              다음
            </Button>
          ) : (
            <Button
              onClick={() => nextOnClick()}
              className="bottombtn bottombtn-b"
              size="lg"
              color="primary"
              type="button"
            >
              다음
            </Button>
          )}
        </ButtonGroup>
      </div>
      <DrawSign
        isOpen={isDrawSignModalOpen}
        setIsOpen={setIsDrawSignModalOpen}
        setDrawCheck={setDrawCheck}
      />
      <Agree1
        isAgree1pdf={isAgree1pdf}
        setAgree1pdf={setAgree1pdf}
        setAgree1={setAgree1}
      ></Agree1>
    </div>
  );
};

export default AgreeForm;
